import { Redirect, useActivePageRegistration } from "@hex-insights/router";
import { MessageGroupUtilities } from "@hex-insights/verita-romania.shared";
import { MessageGroupsList } from "../Components";
import { messagingCreatePageInfo } from "../CreatePage/pageinfo";
import { messagingIndexPageInfo } from "./pageinfo";

export function MessagingIndexPage() {
	useActivePageRegistration(messagingIndexPageInfo);

	const isWide = MessageGroupUtilities.useIsScreenWideForSideList();

	if (isWide) {
		return <Redirect to={messagingCreatePageInfo.to} />;
	}

	return <MessageGroupsList style={{ height: "var(--content-area---height)" }} />;
}
